import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";

interface IHandleGet {
  itensPerPage: number;
  currentPage: number;
  nameSearch: string;
}

export const useHttpTableAdministradora = () => {
  const { handleGetAlert } = useLayoutMainContext();
  const { setQtd_registros, setLoadingTable } = useConfigPageContext();

  const { setListAdministradora } = useContextComissoes();

  const handleGet = async (body: IHandleGet) => {
    setLoadingTable(true);

    api
      .post("/comissoes/GetAdministradoras", {
        ...body,
        page: body.currentPage,
        limit: body.itensPerPage,
        filter: body.nameSearch,
      })
      .then((res) => {
        setListAdministradora(res.data.data);
        setQtd_registros(res.data.count);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoadingTable(false));
  };

  return { handleGet };
};
